
// export const backendUrl = "http://127.0.0.1:8000";
// export const backendUrl = "https://testingbackend.dynamitech.in";
export const backendUrl = "https://backend.dynamitech.in";

// export const domain = "http://127.0.0.1:8000/api/v2";
// export const domain = "https://testingbackend.dynamitech.in/api/v2";
export const domain = "https://backend.dynamitech.in/api/v1";

// export const frontendUrl = "http://localhost:3000";
// export const frontendUrl = "https://testing.dynamitech.in";
export const frontendUrl = "https://app.dynamitech.in";

// export const domain = process.env.REACT_APP_BASE_URL
// export const domain = process.env.REACT_APP_BASE_URL_TEST;

